import React, { useEffect, useState } from 'react';

// styling
import { Colors, Spacing } from "_styles";

const TimelineCard = (props) => {

    return (
        <div
            style={{
                border: '1px solid lightgrey',
                borderTopWidth: '5px',
                borderTopColor: Colors.PRM_LIGHT_BLUE,
                maxHeight: props.height,
                height: props.height,
                width:'100%'
                //position: "relative",
               // borderStyle:'solid', borderWidth:1 
            }}>
            {props.children}
        </div>
    );
};

export default TimelineCard;
